module.exports = __webpack_public_path__ + "images/pro/ic-storage-gift-1e7f5305b563fa8f17362863a0d8b4bd.png";